// @ts-nocheck
import get from 'lodash/get'
import { Tooltip, Typography } from 'opensolar-ui'
import { FunctionComponent, HtmlHTMLAttributes } from 'react'
import pure from 'recompose/pure'

import sanitizeRestProps from './sanitizeRestProps'
import { FieldProps, fieldPropTypes, InjectedFieldProps } from './types'

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = (e) => e.stopPropagation()

const EmailField: FunctionComponent<FieldProps & InjectedFieldProps & HtmlHTMLAttributes<HTMLAnchorElement>> = ({
  addLabel = true,
  className,
  source,
  record = {},
  emptyText,
  tooltipProps,
  ...rest
}) => {
  const value = get(record, source)

  if (value == null) {
    return emptyText ? (
      <Typography component="span" variant="body2" className={className} {...sanitizeRestProps(rest)}>
        {emptyText}
      </Typography>
    ) : null
  }

  return (
    <Tooltip {...tooltipProps} PopperProps={{ style: { zIndex: 2001 } }} title={value} enterDelay={300}>
      <a className={className} href={`mailto:${value}`} onClick={stopPropagation} {...sanitizeRestProps(rest)}>
        {value}
      </a>
    </Tooltip>
  )
}

const EnhancedEmailField = pure<FieldProps & HtmlHTMLAttributes<HTMLAnchorElement>>(EmailField)

EnhancedEmailField.propTypes = fieldPropTypes
EnhancedEmailField.displayName = 'EnhancedEmailField'

export default EnhancedEmailField
